import type { AxiosRequestConfig } from 'axios';

import type { ApiV1 } from '@teamworksdev/influencer/core';

import {
	getSingle,
	isApiError,
} from './utilities/provider';

const RESOURCE = 'maven';

export function useMavenService(config?: Omit<AxiosRequestConfig, 'key'>) {
	const getMavenUser = async () => {
		const response = await getSingle<ApiV1.GetMavenUserResponse['data']>(`${RESOURCE}/user`, '', {
			key: 'getMavenUser',
			...config,
		});
		if (isApiError(response)) throw response;
		return response.data;
	};

	return {
		getMavenUser,
	};
}
